import { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getPlatformFee, savePlatformFee } from "store/platform-fees"

export function useCardProcessingFee({ enabled = false } = {}) {
  const dispatch = useDispatch()
  const platformFeeData = useSelector((state) => state.platformFees?.data)
  const isLoading = useSelector((state) => state.platformFees?.loading || false)
  const isSaving = useSelector((state) => state.platformFees?.save?.loading || false)

  const [passFeeToGuest, setPassFeeToGuest] = useState(false)
  const [cardFeeAsLineItem, setCardFeeAsLineItem] = useState(false)

  useEffect(() => {
    if (enabled) dispatch(getPlatformFee())
  }, [dispatch, enabled])

  useEffect(() => {
    if (platformFeeData) {
      setPassFeeToGuest(platformFeeData.card_fee_passthrough_enabled ?? false)
      setCardFeeAsLineItem(platformFeeData.card_fee_show_as_line_item ?? false)
    }
  }, [platformFeeData])

  const handleToggle = async (checked) => {
    setPassFeeToGuest(checked)
    await dispatch(savePlatformFee({ card_fee_passthrough_enabled: checked }))
  }

  const handleToggleCardFeeLineItem = async (checked) => {
    setCardFeeAsLineItem(checked)
    try {
      await dispatch(savePlatformFee({ card_fee_show_as_line_item: checked }))
    } catch (error) {
      setCardFeeAsLineItem(!checked)
      console.error(error || "Failed to update card fee line item setting")
    }
  }

  return { passFeeToGuest, handleToggle, isLoading, isSaving, cardFeeAsLineItem, handleToggleCardFeeLineItem }
}
